import { Component, OnInit } from '@angular/core';
import { MessageService } from '@shared/services/message.service';
import { FieldType } from '@ngx-formly/core';
import { EditorDialogComponent } from '@shared/components/dialogs/editor-dialog/editor-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'db-custom-field-checkbox',
  templateUrl: './custom-field-checkbox.component.html',
  styleUrls: ['./custom-field-checkbox.component.scss']
})
export class CustomFieldCheckboxComponent extends FieldType implements OnInit {
  customFieldRadioDialogRef: MatDialogRef<EditorDialogComponent>;

  constructor(
    private messageService: MessageService,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnInit() {
  }

  editField(f) {
    // send message to subscribers via observable subject
    this.messageService.sendMessage(f.id.replace('_Text', ''));
    return false;
  }
  deleteField(field) {
    console.log('delete:' + field.id);
    this.messageService.sendMessage('delete:' + field.id);
    return false;
  }

  openCustomFieldRadioDialog() {
    this.customFieldRadioDialogRef = this.dialog.open(EditorDialogComponent, {
      panelClass: 'db-dialog',
      data: {
        formControl: this.formControl,
        field: this.field
      }
    });
  }
}
